import { Enum } from '@lighthouse/tools'

import type {
    AlignMent,
    AnchorProtocol,
    BackgroundNoImageProtocol,
    BackgroundProtocol,
    CursorProtocol,
    FilterFormType,
    IconDecorationProtocol,
    TextBreakPointProtocol,
    VariableADTvalue
} from '../../protocols'
import type { EventsProtocol } from '../../protocols/event'
import { BlockType } from '../Basic'
import { BaseBlock } from './BaseBlock'

export const TABS_TYPE = Enum('LINE', 'ROUND', 'CARD_SLOT', 'SEGMENTED')
export type TabsType = Enum<typeof TABS_TYPE>

export const TABS_SEGMENTED_RADIUS = Enum('xs', 'sm', 'md', 'xl')
export type TabsSegmentedRadius = Enum<typeof TABS_SEGMENTED_RADIUS>

export type TabsColorConfig = {
    color?: BackgroundNoImageProtocol
    iconColor?: BackgroundNoImageProtocol
    background?: BackgroundProtocol
    borderColor?: BackgroundNoImageProtocol
}

export interface TabBaseConfig extends EventsProtocol {
    id: string
    name: string
    tabIcon: IconDecorationProtocol
    iconPosition: Exclude<AlignMent, 'center'>
    visibilityFilter?: FilterFormType
}

export interface TabStyleConfig extends TabsColorConfig {
    id: string
    hover?: TabsColorConfig
    active?: TabsColorConfig
}

export type TabConfig = TabBaseConfig & TabStyleConfig

export type TabVariantConfig = Record<
    TabsType,
    {
        align: AlignMent
        styleList: TabStyleConfig[]
    }
>

export interface TabsBlockConfig extends TextBreakPointProtocol, AnchorProtocol {
    variant: TabsType
    variantMap: TabVariantConfig

    defaultTabIndex: VariableADTvalue

    baseList: TabBaseConfig[]

    cursor?: CursorProtocol
}

export abstract class TabsBlockAbstract extends BaseBlock {
    type = BlockType.tabs

    abstract override config: TabsBlockConfig
}
